import {makeStyles} from "@material-ui/core/styles";

const drawerWidth = 240;
export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px) !important`,
    // zIndex: theme.zIndex.drawer + 1,
    // transition: theme.transitions.create(["width", "margin"], {
    //     easing: theme.transitions.easing.sharp,
    //     duration: theme.transitions.duration.leavingScreen,
    // }),
    // background: "orange",
    // marginLeft: drawerWidth,
    // width: `calc(100% - ${drawerWidth}px)`,
  },
  appBarShift: {
    backgroundColor: 'transparent',
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px) !important`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarShift1: {
    // backgroundColor: 'transparent',
    marginLeft: 75,
    width: `calc(100% - ${75}px) !important`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 6,
    fontSize: 25,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    backgroundColor: 'orange',
    whiteSpace: "nowrap",
    paddingBottom: 25,
    height: '100%',
    borderTopRightRadius: 40,
    // borderBottomRightRadius:30
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    // backgroundColor: "#559E46",// sidebar background color
    backgroundColor: "#33a137",// sidebar background color
    // backgroundColor:'red',
    // display:'flex',
    // alignItems:'center',
    // justifyContent:'center',
    color: 'white',
    height: '90%',
    // marignTop:65

  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
    backgroundColor: "#559E46",// sidebar background color
    color:'white'
    // top:65
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: 'column',
    paddingBottom: 250
  }, small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  content: {
    flexGrow: 1,
    // padding: theme.spacing(3),
    padding: 0,
    position: "relative",
    // top: 60,
    // display:'flex',
    // justifyContent:'flex-start',
    overflow: "hidden",
    backgroundColor: 'transparent',
    // paddingLeft: 20,
    width: '-moz-available',
    // top: 65
    // overflowX: 'auto'
  },
}));
